// @ts-ignore
const req = require.context("./components", true, /\.tsx$/);

const componentRegistry: Record<string, React.FC<any>> = {};

req.keys().forEach((fileName: string) => {
    const mod = req(fileName);
    // Extract filename without extension as component name
    const name = fileName.split("/").pop()!.replace(/\.\w+$/, "");
    if (mod.default) {
        componentRegistry[name] = mod.default;
    }
});

export default componentRegistry;